module.exports = __webpack_public_path__ + "media/img/frontend_application/venue/full-bar-icon-1e0987a0cd6413bdc73ecd0c851758dd.png";